import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_14 = {
  key: 0,
  class: "field"
}
const _hoisted_15 = { class: "control" }
const _hoisted_16 = { class: "field has-addons" }
const _hoisted_17 = { class: "control is-expanded" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  value: "null",
  selected: ""
}
const _hoisted_21 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_22 = { class: "control" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "icon" }
const _hoisted_25 = {
  key: 1,
  class: "field"
}
const _hoisted_26 = { class: "control" }
const _hoisted_27 = { class: "select is-fullwidth" }
const _hoisted_28 = { class: "field" }
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "field has-addons" }
const _hoisted_31 = { class: "control is-expanded" }
const _hoisted_32 = { class: "control" }
const _hoisted_33 = { class: "icon" }
const _hoisted_34 = { class: "field" }
const _hoisted_35 = { class: "control" }
const _hoisted_36 = { class: "field has-addons" }
const _hoisted_37 = { class: "control is-expanded" }
const _hoisted_38 = { class: "control" }
const _hoisted_39 = { class: "icon" }
const _hoisted_40 = {
  key: 2,
  class: "field"
}
const _hoisted_41 = { class: "control" }
const _hoisted_42 = { class: "field has-addons" }
const _hoisted_43 = { class: "control is-expanded" }
const _hoisted_44 = { class: "control" }
const _hoisted_45 = { class: "icon" }
const _hoisted_46 = { class: "deleted-services" }

import { required, numeric } from '@vuelidate/validators';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCopy, faSync } from '@fortawesome/free-solid-svg-icons';
import Toast from '@/shared/services/toast';
import { govNotifyApi } from './services/govNotifyApi';
import { GovNotifyInstalledApp, GovNotifyTemplate, InstallGovNotifyRequest } from './models';
import GovNotifyServiceConfiguration from './components/GovNotifyServiceConfiguration.vue';
import { GovNotifyServiceViewModel } from './models/govNotifyServiceViewModel';
import AppConfirmModal from '../shared/components/AppConfirmModal.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { useClipboard } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'govuknotifysmsConfig',
  emits: ["loaded", "configSaved"],
  setup(__props, { emit: __emit }) {

library.add(faCopy);
library.add(faSync);

const { copy } = useClipboard();
const router = useRouter();
const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const currentApp = computed(() => store.getters.currentApp);

const messageCallbackUrl: string = govNotifyApi.getMessageWebhookUrl();
const deliveryCallbackUrl: string = govNotifyApi.getDeliveryWebhookUrl();

const deletedGovNotifyServices = ref<GovNotifyServiceViewModel[]>([]);
const govNotifyApp = ref<GovNotifyInstalledApp | null>(null);
const bearerToken = ref('');
const isAppInstalled = ref(false);
const apiKey = ref('');
const name = ref('');
const phoneNumber = ref('');
const serviceId = ref('');
const templates = ref<GovNotifyTemplate[]>([]);
const selectedTemplate = ref<GovNotifyTemplate | null>(null);
const services = ref<GovNotifyServiceViewModel[]>([]);
const loadingTemplates = ref(false);
const loadingServices = ref(true);
const actionInProgress = ref(false);
const showConfirmationModal = ref(false);
const showDeleteConfirmationModal = ref(false);
const hasConfirmedDiscard = ref(false);
const appUnsavedState = ref(false);

const hasMultipleGovNotifyServicesEnabled = computed(
  () => !!currentWorkspace.value.features.multipleIdentitiesPerChannelEnabled,
);

const validations = {
  apiKey: { required },
  selectedTemplate: { required },
  name: { required },
  phoneNumber: { required, numeric },
};

const $v = hasMultipleGovNotifyServicesEnabled.value
  ? useVuelidate()
  : useVuelidate(validations, { apiKey, selectedTemplate, name, phoneNumber });

const emit = __emit;

let routerHookFn: any; // A function that will be called to destroy the router beforeLeave hook.

onBeforeMount(async () => bindRouterHook());
onBeforeUnmount(() => {
  if (typeof routerHookFn === 'function') routerHookFn();
});

onMounted(async () => {
  if (currentApp.value.isInstalled) {
    try {
      await loadApp();
      if (hasMultipleGovNotifyServicesEnabled.value) {
        await loadServices();
      } else if (!isAppInstalled.value) {
        const result = await govNotifyApi.getBearerToken(currentWorkspace.value.id);
        serviceId.value = getServiceIdFromBearerToken(result.bearerToken);
        bearerToken.value = result.bearerToken;
      }
    } finally {
      emit('loaded');
    }
  } else {
    emit('loaded');
  }
});

function bindRouterHook() {
  routerHookFn = router.beforeEach((to, from, next) => {
    try {
      if (appUnsavedState.value && !hasConfirmedDiscard.value) {
        showConfirmationModal.value = true;
      } else {
        next();
      }
    } catch {
      console.warn('Ignore unbind route exception');
    }
  });
}

async function loadApp() {
  try {
    govNotifyApp.value = await govNotifyApi.getInstalledApp(currentWorkspace.value.id);
    isAppInstalled.value = true;

    if (govNotifyApp.value) {
      apiKey.value = govNotifyApp.value.notifyApiKey;
      name.value = govNotifyApp.value.name;
      phoneNumber.value = govNotifyApp.value.phoneNumber;
    }
  } catch (err: any) {
    // if it's not found, then we haven't installed the app fully, so let them fill in the form
    if (err.status === 404) {
      isAppInstalled.value = false;
    }
  }
}

async function loadServices() {
  loadingServices.value = true;
  try {
    services.value = await govNotifyApi.getServices(currentWorkspace.value.id);
  } catch (err: any) {
    if (err.status === 404) {
      services.value = [];
    }
    Toast.showError(err.message);
  } finally {
    loadingServices.value = false;
  }
}

function canLoadTemplates() {
  return !loadingTemplates.value && apiKey.value.length > 0;
}

function loadTemplates() {
  copyToClipboard(bearerToken.value);
  if (!canLoadTemplates()) {
    return;
  }

  loadingTemplates.value = true;

  govNotifyApi
    .getTemplates(currentWorkspace.value.id, apiKey.value)
    .then((res) => {
      templates.value = res.templates;
    })
    .catch((err) => Toast.showError(err.message))
    .finally(() => {
      loadingTemplates.value = false;
      if (templates.value.length === 0 && $v.value.selectedTemplate) {
        $v.value.selectedTemplate.$touch();
      }
    });
}

function copyToClipboard(text: string) {
  copy(text);
  Toast.showInfo('Copied to clipboard');
}

function hasGovNotifyInstalledApp() {
  return govNotifyApp.value !== null;
}

function cancel(force?: boolean) {
  if (appUnsavedState.value && !force) {
    showConfirmationModal.value = true;
    return;
  }
  router.push({ name: 'apps' });
}

function handleServiceChange(changedServices: Array<Partial<GovNotifyServiceViewModel>>) {
  // Append any deleted services to the array so the user needs to confirm they want to delete them.
  deletedGovNotifyServices.value.push(...services.value.filter((s) => !s.isDraft && !changedServices.includes(s)));

  // Set the state of the service the unsaved so the user then needs to confirm they want to discard changes.
  appUnsavedState.value = true;
  hasConfirmedDiscard.value = false;

  // Update the services array
  services.value = changedServices.map(
    (s: Partial<GovNotifyServiceViewModel>) => Object.assign({}, s) as GovNotifyServiceViewModel,
  );
}

const submitIsDisabled = computed(() => $v.value.$invalid);

function save(force?: boolean) {
  // If we have non-draft services which have been deleted, show the confirmation modal.
  if (deletedGovNotifyServices.value.length > 0 && !force) {
    showDeleteConfirmationModal.value = true;
    return;
  }
  if (actionInProgress.value) {
    return;
  }
  actionInProgress.value = true;
  if (hasMultipleGovNotifyServicesEnabled.value) {
    saveMultiService();
  } else {
    saveSingleService();
  }
}

async function saveMultiService() {
  try {
    if (isAppInstalled.value === false) {
      const installRequest = {
        installId: currentApp.value.installedAppId,
        workspaceId: currentWorkspace.value.id,
      } as InstallGovNotifyRequest;
      await govNotifyApi.install(installRequest);
    }
    await govNotifyApi.updateServices(currentWorkspace.value.id, saveServiceRequest.value);
    appUnsavedState.value = false;
    emit('configSaved');
  } catch (err: any) {
    Toast.showError(err.message);
  } finally {
    actionInProgress.value = false;
  }
}

function saveSingleService() {
  if (!selectedTemplate.value) {
    return;
  }

  const request = {
    installId: currentApp.value.installedAppId,
    workspaceId: currentWorkspace.value.id,
    notifyApiKey: apiKey.value,
    templateId: selectedTemplate.value.id,
    templateName: selectedTemplate.value.name,
    templateBody: selectedTemplate.value.body,
    serviceId: serviceId.value,
    name: name.value,
    phoneNumber: phoneNumber.value,
  } as InstallGovNotifyRequest;

  govNotifyApi
    .install(request)
    .then(() => {
      appUnsavedState.value = false;
      emit('configSaved');
    })
    .catch((err) => Toast.showError(err.message))
    .finally(() => (actionInProgress.value = false));
}

const saveServiceRequest = computed<GovNotifyServiceViewModel[]>(() => {
  // ():  {
  return services.value.map((service) => {
    if (!service.isDraft) {
      return service;
    }
    return {
      id: service.id,
      name: service.name,
      phoneNumber: service.phoneNumber,
      templateId: service.selectedTemplate!.id,
      templateName: service.selectedTemplate!.name,
      templateBody: service.selectedTemplate!.body,
      notifyApiKey: service.notifyApiKey,
    };
  });
});

function getServiceIdFromBearerToken(bearerToken: string) {
  const claims = JSON.parse(atob(bearerToken.split('.')[1]));
  return claims.serviceId;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("fieldset", {
    disabled: hasGovNotifyInstalledApp() && !hasMultipleGovNotifyServicesEnabled.value
  }, [
    (hasMultipleGovNotifyServicesEnabled.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(GovNotifyServiceConfiguration, {
            value: services.value,
            loading: loadingServices.value,
            onInput: handleServiceChange
          }, null, 8, ["value", "loading"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label" }, "Service Name", -1)),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { 'is-danger': _unref($v).name.$invalid && _unref($v).name.$dirty }]),
                type: "text",
                placeholder: "Enter Service name",
                required: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).name.$touch()))
              }, null, 34), [
                [
                  _vModelText,
                  name.value,
                  void 0,
                  {
                    trim: true,
                    lazy: true
                  }
                ]
              ]),
              (_unref($v).name.$invalid && _unref($v).name.$dirty)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Name is required"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { 'is-danger': _unref($v).phoneNumber.$invalid && _unref($v).phoneNumber.$dirty }]),
                type: "text",
                placeholder: "Enter Phone Number",
                required: "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneNumber).value = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref($v).phoneNumber.$touch()))
              }, null, 34), [
                [
                  _vModelText,
                  phoneNumber.value,
                  void 0,
                  {
                    trim: true,
                    lazy: true
                  }
                ]
              ]),
              (_unref($v).phoneNumber.$invalid && _unref($v).phoneNumber.$dirty)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Phone Number is required and must be numeric "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label" }, "API Key", -1)),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { 'is-danger': _unref($v).apiKey.$invalid && _unref($v).apiKey.$dirty }]),
                type: "text",
                placeholder: "Enter API key here",
                required: "",
                disabled: loadingTemplates.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((apiKey).value = $event)),
                onChange: _cache[5] || (_cache[5] = ($event: any) => {
              _unref($v).apiKey.$touch();
              loadTemplates();
            })
              }, null, 42, _hoisted_12), [
                [
                  _vModelText,
                  apiKey.value,
                  void 0,
                  {
                    trim: true,
                    lazy: true
                  }
                ]
              ]),
              (_unref($v).apiKey.$invalid && _unref($v).apiKey.$dirty)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, "The API key is required"))
                : _createCommentVNode("", true)
            ])
          ]),
          (!hasGovNotifyInstalledApp())
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label" }, "Choose a Template", -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["select is-fullwidth", {
                  'is-loading': loadingTemplates.value,
                  'is-danger': _unref($v).selectedTemplate.$invalid && _unref($v).selectedTemplate.$dirty,
                }])
                      }, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedTemplate).value = $event)),
                          disabled: !canLoadTemplates()
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (template) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: template.id,
                              value: template
                            }, _toDisplayString(template.name), 9, _hoisted_19))
                          }), 128)),
                          (templates.value.length === 0)
                            ? (_openBlock(), _createElementBlock("option", _hoisted_20, "<No templates configured>"))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_18), [
                          [_vModelSelect, selectedTemplate.value]
                        ])
                      ], 2),
                      (_unref($v).selectedTemplate.$invalid && _unref($v).selectedTemplate.$dirty)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, " The template is required "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_22, [
                      _createElementVNode("button", {
                        class: "button is-info",
                        disabled: !canLoadTemplates(),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (loadTemplates()))
                      }, [
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(_component_font_awesome_icon, { icon: "sync" })
                        ])
                      ], 8, _hoisted_23)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (hasGovNotifyInstalledApp())
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label" }, "Template", -1)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("select", null, [
                      _createElementVNode("option", null, _toDisplayString(govNotifyApp.value?.templateName), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label" }, "Delivery Receipts Callback URL", -1)),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    disabled: "",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(deliveryCallbackUrl) ? (deliveryCallbackUrl).value = $event : null))
                  }, null, 512), [
                    [_vModelText, _unref(deliveryCallbackUrl)]
                  ])
                ]),
                _createElementVNode("p", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "button is-info",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (copyToClipboard(_unref(deliveryCallbackUrl))))
                  }, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_font_awesome_icon, { icon: "copy" })
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label" }, "Received Messages Callback URL", -1)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    disabled: "",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(messageCallbackUrl) ? (messageCallbackUrl).value = $event : null))
                  }, null, 512), [
                    [_vModelText, _unref(messageCallbackUrl)]
                  ])
                ]),
                _createElementVNode("p", _hoisted_38, [
                  _createElementVNode("button", {
                    class: "button is-info",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (copyToClipboard(_unref(messageCallbackUrl))))
                  }, [
                    _createElementVNode("span", _hoisted_39, [
                      _createVNode(_component_font_awesome_icon, { icon: "copy" })
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (!hasGovNotifyInstalledApp())
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "label" }, "Bearer Token", -1)),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _withDirectives(_createElementVNode("input", {
                        class: "input",
                        type: "text",
                        disabled: "",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((bearerToken).value = $event))
                      }, null, 512), [
                        [_vModelText, bearerToken.value]
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_44, [
                      _createElementVNode("button", {
                        class: "button is-info",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (copyToClipboard(bearerToken.value)))
                      }, [
                        _createElementVNode("span", _hoisted_45, [
                          _createVNode(_component_font_awesome_icon, { icon: "copy" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_n_button_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_n_button, {
          variant: "primary",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (save())),
          disabled: submitIsDisabled.value,
          loading: actionInProgress.value
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [
            _createTextVNode(" Submit ")
          ])),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_component_n_button, {
          onClick: _cache[15] || (_cache[15] = ($event: any) => (cancel())),
          variant: "primary--outline"
        }, {
          default: _withCtx(() => _cache[29] || (_cache[29] = [
            _createTextVNode("Cancel")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    (showConfirmationModal.value)
      ? (_openBlock(), _createBlock(AppConfirmModal, {
          key: 2,
          title: "Discard Changes",
          onConfirm: _cache[16] || (_cache[16] = ($event: any) => {
        hasConfirmedDiscard.value = true;
        cancel(true);
      }),
          onCancel: _cache[17] || (_cache[17] = ($event: any) => (showConfirmationModal.value = false))
        }, {
          default: _withCtx(() => _cache[30] || (_cache[30] = [
            _createElementVNode("p", null, "All changes you've made to your GovNotify Services will be discarded.", -1),
            _createElementVNode("p", null, "Are you sure you want to cancel?", -1)
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    (showDeleteConfirmationModal.value)
      ? (_openBlock(), _createBlock(AppConfirmModal, {
          key: 3,
          title: "Delete Services",
          onConfirm: _cache[18] || (_cache[18] = ($event: any) => (save(true))),
          onCancel: _cache[19] || (_cache[19] = ($event: any) => (showDeleteConfirmationModal.value = false))
        }, {
          default: _withCtx(() => [
            _cache[31] || (_cache[31] = _createElementVNode("p", null, "Are you sure you want to delete the following services? The action is irreversible.", -1)),
            _createElementVNode("ul", _hoisted_46, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deletedGovNotifyServices.value, (service) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: service.id
                }, _toDisplayString(service.name), 1))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})